module.exports = __webpack_public_path__ + "static/media/picture8.ea1c3641.jpg";